import React from "react";
import { Redirect } from "react-router";

/** Anyone still on step 3 or 4 of the old onboarding moves on to the preferences. */
const RemovedOnboardingStep = () => <Redirect to="/impostazioni-iniziali/5" />;

export default RemovedOnboardingStep;
